<div class="searchable-dropdown">
    <input (click)="selectAll($event)"
           (focus)="this.isListVisible.set(true)"
           [ngModel]="filterValue()"
           [autocomplete]="false"
           (ngModelChange)="onInputChange($event)"
           class="input-M peer"
           id="customer"
           type="search"
           [disabled]="disabled()"
           placeholder="" />
    @if (isListVisible()) {
        <ul class="list whitespace-nowrap">
            @for (option of customers(); track option.id) {
                <li class="item" (click)="onOptionSelected(option.id)">
                    {{ option.customerName }}
                </li>
            } @empty {
                <li class="item">
                    No Result Found
                </li>
            }
        </ul>
    }
    <label for="customer" class="floating-c-lbl">Customer @if (true) {
        <span class="text-red-700">*</span>
    } </label>
</div>
